import React from "react";
import Meta from "../../components/custom-ui/meta/Meta";
import { requireAuth } from "../../providers/auth";
import { useAuth } from "../../providers/auth";
import {
  isSuperAdmin,
  useAdminCommunityHubs,
} from "../../data/communityHub";
import CommunityPostCard from "../../components/communityPostCard/communityPostCard";
import NewHubModal from "../../components/community/admin/NewHubModal";
import useModal from "../../hooks/useModal";
import { Plus } from "lucide-react";
import ToastAlert from "../../components/custom-ui/toast-alert/ToastAlert";

function AdminCommunityPage() {
  const { user }: any = useAuth();
  const role = user?.claims?.role;
  const email = user?.email;
  const superAdmin = isSuperAdmin(role);

  const { data: communityHub = [] } = useAdminCommunityHubs(
    superAdmin
      ? { adminView: true }
      : { moderatorEmail: email },
  );

  const newHubModal = useModal();

  const moderatorBy = {
    email: email || "",
    name: user?.name || user?.displayName || email || "Moderator",
  };

  return (
    <div className="pt-32 min-h-screen" style={{ background: "rgb(244, 247, 248)" }}>
      <Meta title="Community" />

      <div
        style={{
          maxWidth: 1608,
          margin: "0 auto",
          padding: "36px 60px 80px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            marginBottom: 24,
          }}
        >
          <div>
            <h2
              style={{
                fontWeight: 800,
                fontSize: 32,
                lineHeight: 1.1,
                color: "rgb(21, 65, 94)",
                margin: "0 0 6px",
              }}
            >
              Community
            </h2>
            <span
              style={{
                fontWeight: 500,
                fontSize: 14,
                lineHeight: 1,
                color: "rgb(97, 97, 97)",
              }}
            >
              {`${communityHub?.length ?? 0} hubs`}
            </span>
          </div>
          {superAdmin && (
            <button
              type="button"
              onClick={newHubModal.toggle}
              className="flex items-center gap-1.5 px-5 py-2.5 text-sm font-semibold text-white bg-instant-teams-teal-Main rounded-lg hover:opacity-90 shrink-0"
            >
              <Plus size={16} strokeWidth={2.5} />
              New Hub
            </button>
          )}
        </div>

        {!communityHub?.length ? (
          <p className="text-gray-500 py-12 text-center">
            {superAdmin
              ? "No community hubs yet. Create your first hub."
              : "You are not assigned as a moderator on any hub."}
          </p>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 20,
              alignItems: "stretch",
            }}
          >
            {communityHub.map((community: any) => (
              <CommunityPostCard
                key={community.id}
                data={community}
                basePath="/admin-community"
              />
            ))}
          </div>
        )}
      </div>

      {newHubModal.isShowing && email && (
        <NewHubModal onClose={newHubModal.toggle} moderatorBy={moderatorBy} />
      )}

      <ToastAlert containerStyle={{ zIndex: 10000 }} />
    </div>
  );
}

export default requireAuth(AdminCommunityPage);
